<template>
  <div data-vuetify>
    <v-app>
      <div class="d-flex flex-column align-center form-container">
        <div v-if="isRca" class="single-form">
          <rca-section />
        </div>
        <div v-if="isGreenCard" class="single-form">
          <green-section />
        </div>
        <div v-if="isCasco" class="single-form">
          <casco-section />
        </div>
        <div v-if="isMedical" class="single-form">
          <medical-section />
        </div>
      </div>
    </v-app>
  </div>
</template>

<script>
import RcaSection from '@/components/rca/RcaSection';
import GreenSection from '@/components/green-card/GreenSection';
import CascoSection from '@/components/casco/CascoSection';
import MedicalSection from '@/components/medical/MedicalSection';

export default {
  name: 'App',
  components: {
    MedicalSection,
    CascoSection,
    GreenSection,
    RcaSection
  },
  props: {
    quoteFormType: {
      type: String,
      default: 'rca'
    },
    siteLanguage: {
      type: String,
      default: null
    }
  },
  computed: {
    isRca() {
      return this.quoteFormType === 'rca';
    },
    isGreenCard() {
      return this.quoteFormType === 'green-card';
    },
    isCasco() {
      return this.quoteFormType === 'casco';
    },
    isMedical() {
      return this.quoteFormType === 'medical';
    }
  }
};
</script>

<style scoped>
::v-deep .v-application--wrap {
  min-height: 600px;
}
.form-container {
  width: 100%;
}
.single-form {
  width: 100% !important;
}
</style>
<style>
/* GLOBAL */
[data-vuetify] {
  overflow-y: hidden !important;
}
.base-button {
  border-radius: 4px 4px 4px 4px !important;
}
.base-button.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: #ababab !important;
  color: rgba(255, 255, 255, 0.8) !important;
}
.form-stepper.v-stepper {
  box-shadow: none !important;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.fadeIn {
  animation-name: fadeIn;
  animation-duration: .4s;
}
@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
.fadeInDown {
  animation-name: fadeInDown;
  animation-duration: .6s;
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

.fadeInUp {
  animation-name: fadeInUp;
  animation-duration: .6s;
}
@keyframes fadeOutFast {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

.fadeOutFast {
  animation-name: fadeOutFast;
  animation-duration: .0s;
}
@keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

.fadeOut {
  animation-name: fadeOut;
  animation-duration: .4s;
}
@keyframes fadeOutDown {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
}

.fadeOutDown {
  animation-name: fadeOutDown;
  animation-duration: .6s;
}
@keyframes fadeOutUp {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
}

.fadeOutUp {
  animation-name: fadeOutUp;
  animation-duration: .6s;
}
</style>
